import axios from "axios";
import { useNavigate } from "react-router-dom";
import { config, isDevMode } from "./Constants";
import {useSelector, useDispatch } from "react-redux";


const URL = config.url;


const useDeliveryPickupAxios = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const token = sessionStorage.getItem("Token");
    
    const DeliveryPickupClient = axios.create({
        baseURL: URL,
        timeout: isDevMode ? 300000 : 15000,
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,    
            "x-session-id": sessionStorage.getItem("SessionID"),     
            Accept: "text/plain"
        },
    });

    DeliveryPickupClient.interceptors.response.use(
        function (response) {
            return response;
        },
        function (error) {
            if (error.response.status === 401) {
                sessionStorage.clear();
                navigate('/', { replace: true });
            }

            return Promise.reject(error);
        }
    );

    return DeliveryPickupClient;
};


export const useDeliveryPickupTokenAxios = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const token = sessionStorage.getItem("Token");
    
    const DeliveryPickupClient = axios.create({
        baseURL: URL,
        timeout: isDevMode ? 300000 : 15000,
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,    
            "x-session-id": sessionStorage.getItem("SessionID"),     
            Accept: "text/plain"
        },
    });

    DeliveryPickupClient.interceptors.response.use(
        function (response) {
            return response;
        },
        function (error) {
            if (error.response.status === 401) {
                sessionStorage.clear();
                navigate('/', { replace: true });
            }

            return Promise.reject(error);
        }
    );

    return DeliveryPickupClient;
};

export const useDeliveryPickupFormData = () => {
    const token = sessionStorage.getItem("Token");
    const DeliveryPickupAxios = axios.create({
        baseURL: URL,
        timeout: 600000,
        headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`
        },
    });

    return DeliveryPickupAxios;
};

export default useDeliveryPickupAxios;